import AddIcon from "@mui/icons-material/Add";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import {
  Box,
  Button,
  Card,
  CardMedia,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Modal,
  Snackbar,
  TextField,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BILightGrey } from "../../assets/helpers";
import {
  FETCH_CLIENT_PICTUREBOARD,
  FETCH_CLIENT_PICTUREBOARD_ALBUMS_V2,
  FETCH_CLIENT_PICTUREBOARD_V2,
  SAVE_CLIENT_PICTUREBOARD
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";

import { AddCircle } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import { setShowalert } from "../../redux/actions/actions";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import TabsComponent from "../component/TabsComponent";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function Pictureboard() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme?.breakpoints?.down("sm"));
  const LANGUAGE = ClientEnglishFallback.ClientPictureboard(
    multiLanguageData?.ClientPictureboard || {}
  );

  const {
    TEXT_ALBUMS,
    TEXT_PICTURE_BOARD,
    TEXT_TAB_ALL,
    TEXT_MY_SUBMISSIONS,
    TEXT_IMAGE_WILL_NOT_VISIBLE,
    TEXT_APPROVES_IT,
    TEXT_PICTURES,
    TEXT_SELECTED_PICTURES,
    TEXT_DESCRIPTION,
    TEXT_NO_PICTURES_YET,
    TEXT_SAY_SOMETHING_ABOUT_THIS,
    BUTTON_CANCEL,
    TEXT_SUBMIT_BUTTON,
    TEXT_WHEN,
    TEXT_APPROVES_YOUR_SUBMISSION
  } = LANGUAGE;

  const [isLoading, setIsLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState(0);
  const [pictureboardData, setPictureboardData] = useState([]);
  const [pictureboarAlbumData, setPictureboarAlbumData] = useState([]);
  const [showAddPictureboard, setShowAddPictureboard] = useState(false);

  // Infinite scroll states for "All" tab
  const [allTabPageNumber, setAllTabPageNumber] = useState(1);
  const [allTabHasMore, setAllTabHasMore] = useState(true);
  const [allTabLoading, setAllTabLoading] = useState(false);

  // Infinite scroll states for "My Submission" tab
  const [mySubmissionPageNumber, setMySubmissionPageNumber] = useState(1);
  const [mySubmissionHasMore, setMySubmissionHasMore] = useState(true);
  const [mySubmissionLoading, setMySubmissionLoading] = useState(false);
  const [showAlbumModel, setShowAlbumModel] = useState(false);
  const [currentAlbumData, setCurrentAlbumData] = useState([]);

  const [pictures, setPictures] = useState([]);
  const inputRef = useRef(null);
  const [description, setDescription] = useState("");
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewerData, setPictureViewerData] = useState([]);
  const [pictureViewIndex, setPictureViewIndex] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    if (isLoading) {
      getInititalData();
    } else {
      // Reset pagination states when switching tabs
      if (currentTab === 0) {
        // Reset "All" tab states
        setAllTabPageNumber(1);
        setAllTabHasMore(true);
        setAllTabLoading(false);
        setPictureboardData([]);
        getPictureboardData(1, false);
      } else if (currentTab === 1) {
        // Reset "My Submission" tab states
        setMySubmissionPageNumber(1);
        setMySubmissionHasMore(true);
        setMySubmissionLoading(false);
        setPictureboardData([]);
        getPictureboardMyData(1, false);
      }
    }
  }, [currentTab]);

  // Check if we need to load more data when content height is less than viewport
  useEffect(() => {
    const checkIfNeedMore = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      // If content doesn't fill the screen and we have more data, load it
      if (scrollHeight <= clientHeight && pictureboardData.length > 0) {
        if (currentTab === 0 && allTabHasMore && !allTabLoading) {
          fetchNextPageAllTab();
        } else if (currentTab === 1 && mySubmissionHasMore && !mySubmissionLoading) {
          fetchNextPageMySubmission();
        }
      }
    };

    // Small delay to ensure DOM is rendered
    const timer = setTimeout(checkIfNeedMore, 100);
    return () => clearTimeout(timer);
  }, [pictureboardData, currentTab, allTabHasMore, mySubmissionHasMore, allTabLoading, mySubmissionLoading]);

  const getInititalData = async () => {
    await getPictureboardData();
    await getPictureboardAlbumData();
  };
  const getPictureboardData = async (pageNr = 1, appendData = false) => {
    // Only show loading on initial load, not on pagination
    if (!appendData) {
      setIsLoading(true);
    } else {
      setAllTabLoading(true);
    }
    try {
      const obj = {
        PageNr: pageNr,
        NrOfRecPerPage: 50,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ],
        SearchList: [
          {
            ClientId: selectedClientData?.ClientId
          }
        ]
      };

      const response = await Postrequestcall(
        FETCH_CLIENT_PICTUREBOARD_V2,
        obj,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        const data = response?.data?.data ?? [];
        if (appendData) {
          // Append new data for infinite scroll
          setPictureboardData((prev) => [...prev, ...data]);
        } else {
          // Replace data for initial load
          setPictureboardData(data);
          // On initial load, if we got a full page, keep hasMore true
          if (data.length === 50) {
            setAllTabHasMore(true);
          }
        }
        // Update hasMore based on data length - stop if no data or less than page size
        if (data.length === 0 || data.length < 50) {
          setAllTabHasMore(false);
        }
      } else {
        // If API fails, stop loading more
        setAllTabHasMore(false);
      }
    } catch (error) {
      console.error("getPictureboardData-> Error Getting PictureBoard Data: ", error);
      setAllTabHasMore(false);
    }
    if (!appendData) {
      setIsLoading(false);
    } else {
      setAllTabLoading(false);
    }
  };
  const getPictureboardMyData = async (pageNr = 1, appendData = false) => {
    // Only show loading on initial load, not on pagination
    if (!appendData) {
      setIsLoading(true);
    } else {
      setMySubmissionLoading(true);
    }
    try {
      const obj = {
        PageNr: pageNr,
        NrOfRecPerPage: 50,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ],
        SearchList: [
          {
            ClientId: selectedClientData?.ClientId,
            ClientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ]
      };

      const response = await Postrequestcall(
        FETCH_CLIENT_PICTUREBOARD,
        obj,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        const data = response?.data?.data ?? [];
        if (appendData) {
          // Append new data for infinite scroll
          setPictureboardData((prev) => [...prev, ...data]);
        } else {
          // Replace data for initial load
          setPictureboardData(data);
          // On initial load, if we got a full page, keep hasMore true
          if (data.length === 50) {
            setMySubmissionHasMore(true);
          }
        }
        // Update hasMore based on data length - stop if no data or less than page size
        if (data.length === 0 || data.length < 50) {
          setMySubmissionHasMore(false);
        }
      } else {
        // If API fails, stop loading more
        setMySubmissionHasMore(false);
      }
    } catch (error) {
      console.error("getPictureboardMyData-> Error Getting Pictureboard My Data: ", error);
      setMySubmissionHasMore(false);
    }
    if (!appendData) {
      setIsLoading(false);
    } else {
      setMySubmissionLoading(false);
    }
  };
  const getPictureboardAlbumData = async () => {
    setIsLoading(true);
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 50,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ],
        SearchList: [
          {
            ClientId: selectedClientData?.ClientId
          }
        ]
      };

      const response = await Postrequestcall(
        FETCH_CLIENT_PICTUREBOARD_ALBUMS_V2,
        obj,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        const data = response?.data?.data ?? [];
        setPictureboarAlbumData(data);
      }
    } catch (error) {
      console.error("getPictureboardAlbumData-> Error Getting Albumb Data: ", error);
    }
    setIsLoading(false);
  };

  // Infinite scroll handler for "All" tab
  const fetchNextPageAllTab = async () => {
    if (!allTabHasMore || allTabLoading) return;
    const nextPage = allTabPageNumber + 1;
    setAllTabPageNumber(nextPage);
    await getPictureboardData(nextPage, true);
  };

  // Infinite scroll handler for "My Submission" tab
  const fetchNextPageMySubmission = async () => {
    if (!mySubmissionHasMore || mySubmissionLoading) return;
    const nextPage = mySubmissionPageNumber + 1;
    setMySubmissionPageNumber(nextPage);
    await getPictureboardMyData(nextPage, true);
  };

  const handleShowAddPictureboard = () => {
    setShowAddPictureboard(true);
  };
  const handleShowAlertModel = () => {
    const alertData = {
      showAlert: true,
      title: "",
      text: `${TEXT_IMAGE_WILL_NOT_VISIBLE} ${selectedClientData?.OrganizationName} ${TEXT_APPROVES_IT}`
    };
    dispatch(setShowalert(alertData));
  };
  const handleHidePictureboard = async (refresh) => {
    setPictures([]);
    setDescription("");
    setShowAddPictureboard(false);
    if (showAlbumModel === true) {
      handleHideAlbumModel();
    }
    if (refresh) {
      // Reset pagination states and reload data
      if (currentTab === 0) {
        setAllTabPageNumber(1);
        setAllTabHasMore(true);
        setAllTabLoading(false);
        setPictureboardData([]);
        await getPictureboardData(1, false);
      } else if (currentTab === 1) {
        setMySubmissionPageNumber(1);
        setMySubmissionHasMore(true);
        setMySubmissionLoading(false);
        setPictureboardData([]);
        await getPictureboardMyData(1, false);
      }
    }
  };
  const handleShowAlbumModel = async (data) => {
    await setCurrentAlbumData([data]);
    await setShowAlbumModel(true);
  };
  const handleHideAlbumModel = async (refresh) => {
    setCurrentAlbumData([]);
    setPictures([]);
    setDescription("");
    setShowAlbumModel(false);
    if (refresh) {
      // Reset pagination states and reload data
      if (currentTab === 0) {
        setAllTabPageNumber(1);
        setAllTabHasMore(true);
        setAllTabLoading(false);
        setPictureboardData([]);
        await getPictureboardData(1, false);
      } else if (currentTab === 1) {
        setMySubmissionPageNumber(1);
        setMySubmissionHasMore(true);
        setMySubmissionLoading(false);
        setPictureboardData([]);
        await getPictureboardMyData(1, false);
      }
    }
  };

  const handleInputClick = () => {
    inputRef.current.click();
  };
  const handleInputChange = (e) => {
    const newData = [];
    const files = e.target.files;
    Array.from(files).forEach((file) => {
      const fileData = {
        file: file,
        url: URL.createObjectURL(file)
      };
      newData.push(fileData);
    });
    e.target.value = "";
    setPictures([...pictures, ...newData]);
  };
  const handleDescriptionChange = (value) => {
    setDescription(value);
  };
  const shouldDisable = () => {
    return pictures?.length > 0;
  };

  const handelImageDelete = (index) => {
    let temp = [...pictures];
    temp.splice(index, 1);
    setPictures(temp);
  };

  const handlesavePictureboardImage = async () => {
    setIsLoading(true);
    let formDataArray = pictures?.map((img) => {
      let formData = new FormData();
      formData.append("id", 0);
      formData.append("ClientEmployeeId", selectedClientData?.ClientEmployeeId);
      formData.append("PictureUrl", img.file);
      formData.append("PictureDescription", description);
      formData.append("AlbumId", currentAlbumData?.[0]?.id ?? 0);
      formData.append("ModifiedBy", loginData?.userInformation?.UserId);
      return formData;
    });

    let promises = formDataArray?.map((formData) =>
      Fileuploadrequestcall(SAVE_CLIENT_PICTUREBOARD, formData, loginData?.accessToken)
    );

    await Promise.all(promises);
    setIsLoading(false);
    handleHidePictureboard(true);
    setCurrentTab(0);
    setSnackbarOpen(true);
  };

  const showAndSetPictureViewer = (data, index) => {
    setPictureViewerData(data);
    setPictureViewIndex(index);
    setPictureViewerOpen(true);
  };
  const hideAndUnsetPictureViewer = () => {
    setPictureViewerData([]);
    setPictureViewIndex(0);
    setPictureViewerOpen(false);
  };
  const Tabs = [
    {
      label: "All",
      value: 0,
      translateLabel: TEXT_TAB_ALL
    },
    {
      label: "My Submission",
      value: 1,
      translateLabel: TEXT_MY_SUBMISSIONS
    }
  ];

  return (
    <>
      <Box>
        {isLoading ? (
          <Loader fullScreen />
        ) : (
          <Grid container spacing={2}>
            {pictureboarAlbumData?.length > 0 && (
              <Grid size={12}>
                <Typography sx={{ fontWeight: 700, mt: 1, color: "text.primary" }} variant="h6">
                  {TEXT_ALBUMS}
                </Typography>
              </Grid>
            )}
            <Grid size={12}>
              <Box
                sx={{ display: "flex" }}
                gap={2.5}
                sx={{
                  overflowX: "auto",
                  scrollbarWidth: 'none',
                  width: '100%',
                  pb: 2,
                  px: 0.5,
                  '&::-webkit-scrollbar': { display: 'none' }
                }}
              >
                {pictureboarAlbumData?.map((album, index) => (
                  <Box
                    key={index}
                    onClick={() => handleShowAlbumModel(album)}
                    sx={{
                      minWidth: 180,
                      width: 180,
                      cursor: "pointer",
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        '& .album-image': { transform: 'scale(1.08)' },
                        '& .album-card': { boxShadow: '0 12px 24px -10px rgba(0,0,0,0.15)' },
                        transform: 'translateY(-4px)'
                      }
                    }}
                  >
                    <Card
                      className="album-card"
                      sx={{
                        height: 180,
                        borderRadius: "20px",
                        position: "relative",
                        overflow: "hidden",
                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                        border: '1px solid #f1f5f9',
                        bgcolor: 'background.paper'
                      }}
                    >
                      {album?.pictureList?.length > 0 ? (
                        <CardMedia
                          component="img"
                          className="album-image"
                          image={album?.pictureList[0]?.thumbFileUrl}
                          sx={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                            transition: 'transform 0.5s ease'
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                            gap: 1
                          }}
                        >
                          <CameraAltIcon sx={{ fontSize: 40, color: 'text.disabled', opacity: 0.5 }} />
                          Image Not Available
                        </Box>
                      )}
                    </Card>

                    <Box sx={{ mt: 1.5, px: 0.5 }}>
                      <Typography sx={{ fontWeight: 700, color: "text.primary", 
                          mb: 0.2,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          lineHeight: 1.2 }} variant="subtitle2">
                        {album?.albumName}
                      </Typography>
                      <Typography variant="caption"  sx={{color: "text.secondary",  fontWeight: 500 }}>
                        {album?.nrofPictures} {TEXT_PICTURES}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>
            <Divider sx={{ height: "1px", width: "100%" }} />

            <Grid size={12}>
              <TabsComponent tabValue={currentTab} tabs={Tabs} setTabsValue={setCurrentTab} />
            </Grid>
            {pictureboardData?.length > 0 ? (
              <Grid size={12}>
                <InfiniteScroll
                  dataLength={pictureboardData.length}
                  next={currentTab === 0 ? fetchNextPageAllTab : fetchNextPageMySubmission}
                  hasMore={currentTab === 0 ? allTabHasMore : mySubmissionHasMore}
                  loader={
                    <Grid sx={{ justifyContent: "center", py: 2 }} container>
                      <CircularProgress size={30} />
                    </Grid>
                  }
                  scrollThreshold={0.8}>
                  <Grid container spacing={1}>
                    {pictureboardData?.map((data, index) => (
                      <Grid
                        key={index}
                        size={{
                          xs: 4,
                          sm: 4,
                          md: 4,
                          lg: 3,
                          xl: 2
                        }}>
                        {/* Square container for images */}
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            paddingTop: "100%", // Creates the aspect ratio of a square
                            overflow: "hidden",
                            borderRadius: "8px" // Optional: add rounded corners
                          }}>
                          <img
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              objectFit: "cover", // Ensures the image covers the container
                              filter: data?.approved === false ? "brightness(0.3)" : "brightness(1)",
                              cursor: "pointer"
                            }}
                            src={data.thumbFileUrl}
                            alt="no data"
                            title="pictureboard images"
                            onClick={() => showAndSetPictureViewer(pictureboardData, index)}
                          />
                          {data?.approved === false && (
                            <IconButton
                              sx={{
                                position: "absolute",
                                bottom: "0px",
                                left: "0px",
                                color: "white",
                                borderRadius: "50%",
                                fontSize: "24px",
                                cursor: "pointer",
                                zIndex: 1
                              }}
                              onClick={handleShowAlertModel}>
                              <ErrorIcon />
                            </IconButton>
                          )}
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </InfiniteScroll>
              </Grid>
            ) : (
              <Grid sx={{ alignItems: "center",  justifyContent: "center", height: "80vh", width: "100%" }} container>
                <Typography sx={{ textAlign: "center" }}>{TEXT_NO_PICTURES_YET}</Typography>
              </Grid>
            )}
          </Grid>
        )}
        <div className="button-div">
          <IconButton
            className="icon-button"
            sx={{ backgroundColor: selectedClientData?.AccentColor }}
            onClick={handleShowAddPictureboard}>
            <AddIcon className="add-icon" />
          </IconButton>
        </div>
      </Box>
      {
        <Modal
          open={showAddPictureboard}
          onClose={() => handleHidePictureboard()}
          aria-labelledby="modal-add-client-support"
          aria-describedby="modal-add-client">
          <Box sx={{ marginTop: 2 }} borderRadius={2} className="client-modal-responsive">
            <Grid container spacing={1}>
              <Grid sx={{ display: "flex", alignItems: "center",  justifyContent: "space-between" }} size={12}>
                <Typography variant="body1" sx={{ color: "initial" }}>
                  {TEXT_SELECTED_PICTURES}
                </Typography>
                <IconButton
                  sx={{
                    color:
                      selectedClientData?.AccentColor !== undefined &&
                        selectedClientData?.AccentColor
                        ? selectedClientData?.AccentColor
                        : BILightGrey
                  }}
                  onClick={() => handleHidePictureboard()}>
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid size={12}>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={1} sx={{ alignItems: "center" }}>
                    <Grid
                      size={{ xs: 3.5, sm: 2.8, md: 2.8 }}
                      sx={{ height: isSmallScreen ? 90 : 130 }}>
                      <Button
                        sx={{
                          width: "100%",
                          height: "100%",
                          color: "GrayText",
                          borderRadius: "10px",
                          backgroundColor: "lightgray",
                          boxShadow: "none",
                          textAlign: "center",
                          p: 0
                        }}
                        variant="text"
                        size="small"
                        component="label">
                        <AddCircle
                          sx={{
                            color:
                              selectedClientData?.AccentColor !== undefined &&
                                selectedClientData?.AccentColor
                                ? selectedClientData?.AccentColor
                                : BILightGrey
                          }}
                        />
                        <input
                          id="timeSheetPicture-upload"
                          type="file"
                          multiple
                          accept="image/*"
                          onChange={(e) => handleInputChange(e)}
                          hidden
                        />
                      </Button>
                    </Grid>

                    <Grid
                      size={{ xs: 8.5, sm: 9.2, md: 9.2 }}
                      sx={{ height: isSmallScreen ? 90 : 130 }}>
                      <ImageList
                        gap={7.5}
                        sx={{
                          width: "100%",
                          height: "100%",
                          margin: 0,
                          padding: 0,
                          flexWrap: "nowrap",
                          overflowX: "auto",
                          display: "flex",
                          scrollbarWidth: "none",
                          borderRadius: "10px",
                          backgroundColor: "white"
                        }}>
                        {pictures?.map((picItem, picIndex) => (
                          <ImageListItem key={picIndex} sx={{ minWidth: isSmallScreen ? 90 : 130 }}>
                            <img
                              src={picItem?.url}
                              alt="pictureboard pictures"
                              style={{
                                borderRadius: 10,
                                width: isSmallScreen ? 90 : 130,
                                height: isSmallScreen ? 90 : 130,
                                objectFit: "cover"
                              }}
                              loading="lazy"
                            />
                            <ImageListItemBar
                              sx={{ background: "none", padding: 1 }}
                              position="top"
                              actionIcon={
                                <IconButton
                                  onClick={() => handelImageDelete(picIndex)}
                                  size="small"
                                  sx={{
                                    color:
                                      selectedClientData?.AccentColor !== undefined &&
                                        selectedClientData?.AccentColor
                                        ? selectedClientData?.AccentColor
                                        : BILightGrey,
                                    backgroundColor: "rgba(0,0,0,0.3)"
                                  }}>
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              }
                              actionPosition="right"
                            />
                          </ImageListItem>
                        ))}
                      </ImageList>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid size={12}>
                <Typography variant="body1" sx={{color: "initial",  fontSize: "smaller" }} >
                  {TEXT_DESCRIPTION}
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  size="small"
                  variant="outlined"
                  rows={5}
                  required
                  fullWidth
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    handleDescriptionChange(inputValue);
                  }}
                  value={description}
                  placeholder={TEXT_SAY_SOMETHING_ABOUT_THIS}
                />
              </Grid>
              <Grid size={6} sx={{ marginTop: 1,  overflowX: "auto", display: "flex" }} >
                <Button variant="outlined" fullWidth onClick={() => handleHidePictureboard()}>
                  {BUTTON_CANCEL}
                </Button>
              </Grid>
              <Grid size={6} sx={{ marginTop: 1,  overflowX: "auto", display: "flex" }} >
                <Button
                  disabled={!shouldDisable() || isLoading}
                  variant="contained"
                  fullWidth
                  onClick={handlesavePictureboardImage}
                  sx={{ backgroundColor: selectedClientData?.AccentColor }}>
                  {isLoading ? (
                    <CircularProgress sx={{ color: selectedClientData?.AccentColor }} size="20px" />
                  ) : (
                    TEXT_SUBMIT_BUTTON
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      }
      {
        <Modal
          open={showAlbumModel}
          onClose={() => handleHideAlbumModel()}
          aria-labelledby="modal-add-client-support"
          aria-describedby="modal-add-client">
          <Box className="client-modal-responsive">
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid sx={{ display: "flex", alignItems: "center",  justifyContent: "space-between" }} size={12}>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {currentAlbumData[0]?.albumName}
                  </Typography>
                  <IconButton
                    sx={{
                      color: selectedClientData?.AccentColor || BILightGrey
                    }}
                    onClick={() => handleHideAlbumModel()}>
                    <CloseIcon />
                  </IconButton>
                </Grid>

                <Grid size={12} sx={{ mt: 1 }}>
                  <Grid container spacing={1.5}>
                    {currentAlbumData[0]?.pictureList?.map((pic, picIndex) => (
                      <Grid
                        key={picIndex}
                        size={{ xs: 4, sm: 3 }}
                      >
                        <Card
                          sx={{
                            borderRadius: "12px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            cursor: "pointer",
                            transition: 'transform 0.2s',
                            '&:hover': { transform: 'scale(1.02)' }
                          }}
                          onClick={() => showAndSetPictureViewer(currentAlbumData[0]?.pictureList, picIndex)}>
                          <CardMedia
                            sx={{
                              height: 100,
                              borderRadius: "12px"
                            }}
                            image={pic.thumbFileUrl}
                            title={currentAlbumData[0]?.albumName}
                          />
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>

                <Grid size={12} sx={{ mt: 2 }}>
                  <Divider />
                </Grid>

                <Grid sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }} size={12}>
                  <IconButton
                    sx={{
                      backgroundColor: selectedClientData?.AccentColor,
                      color: "white",
                      width: 45,
                      height: 45,
                      '&:hover': { backgroundColor: selectedClientData?.AccentColor, opacity: 0.9 }
                    }}
                    onClick={handleShowAddPictureboard}>
                    <AddIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Modal>
      }
      {pictureViewerOpen && (
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => hideAndUnsetPictureViewer()}
          pictures={pictureViewerData?.map((pic) => ({
            src: pic.thumbFileUrl ?? pic.url,
            alt: pic?.pictureDescription
          }))}
          viewerIndex={pictureViewIndex}
        />
      )}

      <Snackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={`${TEXT_WHEN} ${selectedClientData?.OrganizationName} ${TEXT_APPROVES_YOUR_SUBMISSION}`}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        key={"bottomcenter"}
      />
    </>
  );
}

export default Pictureboard;
